import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const skillsAndExperience = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    isStudent: z
      .enum(['Yes', 'No'])
      .nullable()
      .optional()
      .describe('Whether the candidate is a student.'),

    university: z.string().nullable().optional().describe('University name.'),

    faculty: z.string().nullable().optional().describe('Faculty.'),

    speciality: z
      .string()
      .nullable()
      .optional()
      .describe('Speciality or major.'),

    courseYear: z
      .string()
      .nullable()
      .optional()
      .describe('Course year or graduate status.'),

    candidateId: z.number().hidden().describe('Foreign key to Candidate'),

    candidate: belongsTo('Candidate'),
  })
  .describe('Education and experience details for a candidate.')
  .as('SkillsAndExperience');

export { skillsAndExperience as skillsAndExperienceSchema };
